import { render, staticRenderFns } from "./ingredients-filter.vue?vue&type=template&id=f89ca07c&"
import script from "./ingredients-filter.vue?vue&type=script&lang=js&"
export * from "./ingredients-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports